<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'user-form', params: { id: 'new' }}" v-if="!widget">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <div>

      <v-card class="pa-3">
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-text-field
              name="nameOrEmail"
              label="Nome ou Email"
              v-model="nameOrEmail"></v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              :items="clients"
              v-model="client_id"
              item-text="name"
              item-value="id"
              clearable
              :disabled="disabledClient || (clients.length === 0)"
              label="Selecione um cliente">
            </v-select>
          </v-flex>
          <v-flex xs12 md2>
            <v-select
              :items="apiOptions"
              v-model="api_user"
              item-text="description"
              item-value="value"
              clearable
              label="Usuários de Api">
            </v-select>
          </v-flex>
          <v-flex xs12 md12 text-md-center>
            <v-alert
              :value="showAlert"
              type="error">
              Não existem clientes cadastrados no sistema.
            </v-alert>
            <v-btn flat color="primary" @click="search()">
              <v-icon>search</v-icon>
              Pesquisar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
      <v-flex xs12 md12 text-md-center>
        <v-alert
          :value="['master', 'admin'].includes(currentUser.roles[0].slug)"
          type="info">
          URL API: http://ciclosweb.com.br/api/v1/dynamic-select/select-table-or-view?tableName=[TABLE_NAME]&token=[USER_TOKEN]
        </v-alert>
      </v-flex>
      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        :loading="searchLoading"
        class="elevation-0">

        <template slot="items" slot-scope="props">
          <td>
            <v-avatar size="36px" slot="activator">
              <img :src="getImage(props.item.image)" alt="">
            </v-avatar> &nbsp;

            {{ props.item.name }} ({{ props.item.email }})
          </td>
          <td>
            {{ props.item.client ? props.item.client.name : 'Nenhum cliente vinculado' }}
          </td>
          <td>
            {{ props.item.roles.length > 0 ? props.item.roles[0].title : 'Nenhum perfil vinculado' }}
          </td>
          <td>
            {{ props.item.active ? "Ativo" : "Inativo" }}
          </td>
          <td class="text-xs-center">
            <v-tooltip top>
              <v-btn :color="props.item.active ? 'success' : 'dark'" flat icon slot="activator" @click="toggleStatus({ id: props.item.id })">
                <v-icon v-if="props.item.active">toggle_on</v-icon>
                <v-icon v-else>toggle_off</v-icon>
              </v-btn>
              <span>{{ props.item.active ? "Desativar" : "Ativar" }}</span>
            </v-tooltip>

            <v-tooltip top v-if="props.item.api_token">
              <v-btn
                flat
                icon
                slot="activator"
                v-clipboard="props.item.api_token"
                @success="handleSuccess"
                @error="handleError">
                <v-icon>content_copy</v-icon>
              </v-btn>
              <span>Copiar TOKEN</span>
            </v-tooltip>

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" @click="destroy(props.item.id, props.item.name)">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import UserService from '@/features/user/UserService';
import ClientService from '@/features/client/ClientService';

export default {
  name: 'user-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      disabledClient: false,
      showAlert: false,
      loader: null,
      api_user: 'todos',
      headers: [
        {
          text: this.$t('attributes.name'),
          align: 'left',
          sortable: false,
        },
        {
          text: this.$t('attributes.user.client'),
          align: 'left',
          sortable: false,
        },
        {
          text: this.$t('attributes.user.perfil'),
          align: 'left',
          sortable: false,
        },
        {
          text: this.$t('attributes.user.status'),
          align: 'left',
          sortable: false,
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
      clientService: new ClientService(),
      clients: [],
      apiOptions: [
        { id: 1, description: 'SIM', value: 'sim' },
        { id: 2, description: 'NÃO', value: 'nao' },
        { id: 3, description: 'TODOS', value: 'todos' },
      ],
      client_id: null,
      nameOrEmail: null,
      show: false,
      currentUser: null,
    };
  },
  created() {
    this.currentUser = this.$store.state.currentUser;
    if (!UserService.hasProfile(this.currentUser, ['master', 'admin', 'analista'])) {
      if (this.currentUser.client) {
        this.client_id = this.currentUser.client.id;
      }
      this.disabledClient = true;
    }
    this.loadCombos();
  },
  methods: {
    initCrud() {
      this.serviceType = UserService;
      this.routerName = 'user';
    },
    applyFilters(filter) {
      const params = {
        nameOrEmail: this.nameOrEmail,
        api_user: this.api_user,
      };
      if (this.client_id) params.client_id = this.client_id;
      return Object.assign(filter, params);
    },
    getImage(image) {
      let defaultImage = '/static/no_avatar.gif';
      if (image) {
        defaultImage = image;
      }
      return defaultImage;
    },
    async loadCombos() {
      this.clients = await this.clientService.query();
      this.showAlert = (this.clients.length === 0);
      this.search();
    },
    handleSuccess() {
      this.$toast.success('Token copiado com sucesso!');
    },
    handleError() {
      this.$toast.error('Erro ao tentar copiar o token, tente novamente.');
    },
    async toggleStatus({ id }) {
      await UserService.toggleStatus({ id });
      this.search(this.paginator.currentPage);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/user/UserList.vue